export const FAILED = 0
export const SUCCESS = 1
export const REFUNDED = 2 // transaction is succeeded but it was refunded